import script from "./CraftingQuestionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CraftingQuestionDialog.vue?vue&type=script&setup=true&lang=js"

import "./CraftingQuestionDialog.vue?vue&type=style&index=0&id=30fac247&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30fac247"]])

export default __exports__